import { render, staticRenderFns } from "./vsCollapseItem.vue?vue&type=template&id=d47c8bba"
import script from "./vsCollapseItem.vue?vue&type=script&lang=js"
export * from "./vsCollapseItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports